import {css} from 'lit';
export const styles = css`:host {
  --free-label-bg: #ffa000;
  --negotiable-label-bg: #009688;
}

ef-label span + span {
  margin-top: 2px;
  margin-left: 4px;
  padding-left: 4px;
  text-transform: uppercase;
  border-left: 1px dotted #f3f3f3;
  font-size: 12px;
  font-weight: 600;
}

.free {
  --background-primary: var(--free-label-bg);
}

.negotiable {
  --background-primary: var(--negotiable-label-bg);
}
`;
export default styles;
